import { createContext, Dispatch } from 'react';
import { Event } from './useAddUserModalReducer';

export const AddUserModalContext = createContext<{ dispatch: Dispatch<Event> }>({ dispatch: () => {} });
